import {Controller} from '@hotwired/stimulus';
import Swiper, {Autoplay, Navigation, Pagination} from 'swiper';
import {replaceWhitespaceWithBR} from '../helpers';

export default class extends Controller {
	static get targets () {
		return ['currentCount', 'next', 'prev', 'pagination'];
	}

	initialize() {
		this._swiper = null;
		this._config = {};
	}

	connect() {
		this.load();
	}

	disconnect() {
		if (this._swiper) {
			this._swiper.destroy();
			this._swiper = null;
		}
	}
	async load() {
		this._config = this.element.dataset.config ? JSON.parse(this.element.dataset.config) : {};
		const config = this._config;

		config.watchOverflow = true;
		if (config.autoplay) {
			Swiper.use([Autoplay]);
		}

		if (!config.speed) {
			config.speed = 800;
		}

		if (config.navigation || (this.hasNextTarget && this.hasPrevTarget)) {
			Swiper.use([Navigation]);
			config.navigation = {
				nextEl: this.nextTargets,
				prevEl: this.prevTargets
			};
		}

		if (config.pagination || this.hasPaginationTarget) {
			Swiper.use([Pagination]);
			config.pagination = {...{
				el: this.paginationTargets
			}, ...config.pagination};

			if (config.bullets) {
				let bullets = config.bullets;
				config.pagination.renderBullet = (index, className) => {
					let str = replaceWhitespaceWithBR(bullets[index]);
					return '<span class="' + className + '">' + str + '</span>';
				};
				delete config.bullets;
			}
		}

		config.on = {
			init: () => {
				this.removeBulletText();
			}
		};

		if (config.screen) {
			if (window.screen.width < config.screen) {
				delete config.screen;
				this._swiper = new Swiper(this.element, Object.keys(config).length > 0 ? config : undefined);
			}
		} else {
			this._swiper = new Swiper(this.element, Object.keys(config).length > 0 ? config : undefined);
		}
	}

	removeBulletText() {
		if (this.hasPaginationTarget) {
			this.paginationTargets.forEach(pagination => {
				if (pagination.classList.contains('remove-bullets-text')) {
					pagination.querySelectorAll('.swiper-pagination-bullet').forEach((el) => {
						el.innerHTML = '';
					});
				}
			});
		}
	}
}
